import PropTypes from "prop-types";

/**
 * Base shape for ROM cell original data
 */
const romCellOriginalShape = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  revenueQty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  revenueUnitCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  costQty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  costUnitCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  budgetQty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  budgetUnitCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

/**
 * Shared PropTypes for Revenue ROM cell (includes revenueROM)
 */
export const revenueROMCellPropTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      ...romCellOriginalShape,
      revenueROM: PropTypes.object,
    }),
  }),
  onROMChange: PropTypes.func,
  onEdit: PropTypes.func,
};

/**
 * Shared PropTypes for Cost ROM cell (includes costROM)
 */
export const costROMCellPropTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      ...romCellOriginalShape,
      costROM: PropTypes.object,
    }),
  }),
  onROMChange: PropTypes.func,
  onEdit: PropTypes.func,
};

/**
 * Shared PropTypes for Budget ROM cell (includes budgetROM)
 */
export const budgetROMCellPropTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      ...romCellOriginalShape,
      budgetROM: PropTypes.object,
    }),
  }),
  onROMChange: PropTypes.func,
  onEdit: PropTypes.func,
};
